<template>
    <div id="listing-view">
        <flash-message transitionIn="animated swing"></flash-message>
        <b-row>
            <b-col xs="12" lg="12">
                <b-card>
                    <div slot="header">
                        {{ listing.name }}
                    </div>
                    <b-tabs >
                        <b-tab active>
                            <template slot="title">
                                <i class="icon-list"></i> Details
                            </template>
                            <h3>Edit details</h3>
                            <listing-form :listing="listing"  :edit-option="true"></listing-form>
                        </b-tab>
                        <b-tab>
                            <template slot="title">
                                <i class="icon-people"></i> Subscribers
                            </template>
                            Total Subscribers {{ listing.subscribers.length }}
                            <b-row>
                                <b-col md="6">
                                    <g-table
                                            :items="listing.subscribers"
                                            :fields="[
                                                        {key: 'id'},
                                                        {key: 'person.name'},
                                                        {key: 'person.type'},
                                                        {key: 'status'}
                                            ]"
                                            caption="News Letter Subscribers"
                                            base-url="listing"
                                            trailing-url="/subscribe"
                                    >
                                    </g-table>
                                    <button class="btn btn-info" v-show="exportBtn" v-on:click="exportSubscribers">Export</button>
                                    <download-csv class="btn btn-info"
                                            v-show="downloadBtn"
                                            :data="exportCSV"
                                    >
                                        Download Subscribers
                                    </download-csv>
                                </b-col>
                                <b-col md="6">
                                    <subscription-form :listing-id="listingId" :add-option="true" @clicked="onSubscriberCreated" ></subscription-form>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import SubscriptionForm from "../../components/newsletter/Subscription/SubscriptionForm";
    import {Listing} from "../../models/NewsLetter/Listing";
    import ListingForm from "../../components/newsletter/Listing/ListingForm";
    import GTable from "../../components/base/GTable";

    const ListingRepo = RepositoryFactory.get('newsletterListing')

    export default {
        name: 'listing',
        components: {
          GTable,
          ListingForm,
          SubscriptionForm,
        },
        data (){
            return {
                listing: new Listing(),
                exportCSV: [],
                downloadBtn: false,
                exportBtn: true,
            }
        },
        mounted() {
            this.listingId = this.$route.params.listing_id,
            ListingRepo
                .getListing(this.listingId)
                .then(
                    response => (
                        this.listing = response.data.data
                    )
                )
        },
        methods: {
            exportSubscribers() {
                ListingRepo.exportListing(this.listingId)
                    .then(
                        response => (
                            this.exportCSV = response.data,
                            this.downloadBtn = true,
                            this.exportBtn = false
                        )
                    )
            },
            onSubscriberCreated(subscriber) {
                this.listing.subscribers.unshift(subscriber)
            },
        },
    }
</script>
